module.exports = {"header":{"background":"#6887ff"}}


//////////////////
// WEBPACK FOOTER
// ./src/style/theme/theme-info.json
// module id = 1912
// module chunks = 1